import { useState, useEffect, useMemo } from "react"
import { doc, getDocs, updateDoc, collection } from "firebase/firestore"
import { db } from "../../services/firebase"
import { BTN_GHOST, BTN_PRIMARY } from "../../utils/adminConstants"

export default function SeccionVincular({ clientes }) {
  const [usuariosLibres, setUsuariosLibres] = useState([])
  const [cargando, setCargando]             = useState(true)
  const [usuarioSel, setUsuarioSel]         = useState(null)
  const [clienteSel, setClienteSel]         = useState(null)
  const [vinculando, setVinculando]         = useState(false)
  const [exito, setExito]                   = useState(null)
  const [busU, setBusU]                     = useState("")
  const [busC, setBusC]                     = useState("")
  const [ocultando, setOcultando]           = useState(null)
  const [ocultos, setOcultos]               = useState([])
  const [busOcultos, setBusOcultos]         = useState("")
  const [ultimosRegistros, setUltimosRegistros] = useState([])

  // IDs de clientes ya vinculados
  const [idsVinculados, setIdsVinculados] = useState(new Set())

  useEffect(() => {
    async function cargar() {
      setCargando(true)
      try {
        const snap = await getDocs(collection(db, "usuarios_web"))
        const todos = snap.docs.map(d => ({ uid: d.id, ...d.data() }))
        // IDs de clientes ya vinculados (para filtrar lista derecha)
        const vinculados = new Set(
          todos.filter(u => u.id_cliente_asociado).map(u => String(u.id_cliente_asociado))
        )
        setIdsVinculados(vinculados)
        // Separar ocultos de libres
        const sinVincular = todos.filter(u => !u.es_admin && !u.id_cliente_asociado)
        setOcultos(sinVincular.filter(u => u.oculto === true))
        setUsuariosLibres(sinVincular.filter(u => !u.oculto))
        // Últimos 5 registros (con creado_en), ordenados por fecha desc
        const conFecha = todos
          .filter(u => u.creado_en)
          .sort((a, b) => {
            const fa = a.creado_en?.toDate?.() || new Date(a.creado_en)
            const fb = b.creado_en?.toDate?.() || new Date(b.creado_en)
            return fb - fa
          })
          .slice(0, 5)
        setUltimosRegistros(conFecha)
      } catch (e) {
        console.error(e)
      } finally {
        setCargando(false)
      }
    }
    cargar()
  }, [])

  const clientesSinCuenta = useMemo(() =>
    clientes.filter(c => !idsVinculados.has(String(c.id)))
  , [clientes, idsVinculados])

  const usuariosFiltrados = usuariosLibres.filter(u =>
    `${u.nombre} ${u.apellido} ${u.email}`.toLowerCase().includes(busU.toLowerCase())
  )
  const clientesFiltrados = clientesSinCuenta.filter(c =>
    `${c.nombre} ${c.apellido}`.toLowerCase().includes(busC.toLowerCase())
  )

  async function ocultarUsuario(u) {
    setOcultando(u.uid)
    try {
      await updateDoc(doc(db, "usuarios_web", u.uid), { oculto: true })
      setUsuariosLibres(p => p.filter(x => x.uid !== u.uid))
      setOcultos(p => [...p, u])
      if (usuarioSel?.uid === u.uid) setUsuarioSel(null)
    } catch (e) { console.error(e) }
    finally { setOcultando(null) }
  }

  async function desocultar(u) {
    try {
      await updateDoc(doc(db, "usuarios_web", u.uid), { oculto: false })
      setOcultos(p => p.filter(x => x.uid !== u.uid))
      setUsuariosLibres(p => [...p, u])
    } catch (e) { console.error(e) }
  }

  async function vincular() {
    if (!usuarioSel || !clienteSel) return
    setVinculando(true)
    try {
      await updateDoc(doc(db, "usuarios_web", usuarioSel.uid), { id_cliente_asociado: clienteSel.id })
      setExito(`${usuarioSel.nombre} ${usuarioSel.apellido} vinculado con ${clienteSel.nombre} ${clienteSel.apellido}`)
      setUsuariosLibres(p => p.filter(u => u.uid !== usuarioSel.uid))
      setUsuarioSel(null)
      setClienteSel(null)
    } catch (e) {
      console.error(e)
    } finally {
      setVinculando(false)
    }
  }

  return (
    <div>
      <div className="admin__seccion-header">
        <div>
          <div className="admin__seccion-titulo">Vincular clientes</div>
          <div className="admin__seccion-sub">
            {cargando ? "Cargando..." : `${usuariosLibres.length} usuarios sin vincular · ${clientesSinCuenta.length} clientes sin cuenta`}
          </div>
        </div>
      </div>

      {exito && (
        <div style={{ background:"#0a2a1a", border:"1px solid #10b98140", borderRadius:"10px", padding:"12px 16px", marginBottom:"16px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
          <span style={{ color:"#10b981", fontWeight:700, fontSize:"0.875rem" }}>✓ {exito}</span>
          <button onClick={()=>setExito(null)} style={{ background:"none", border:"none", color:"#4b5563", cursor:"pointer" }}>✕</button>
        </div>
      )}

      {/* Barra de confirmación */}
      {usuarioSel && clienteSel && (
        <div style={{ background:"#1e3a5f", border:"1px solid #3b82f640", borderRadius:"12px", padding:"16px 20px", marginBottom:"16px", display:"flex", alignItems:"center", justifyContent:"space-between", gap:"12px", flexWrap:"wrap" }}>
          <div style={{ fontSize:"0.9rem", color:"#e5e7eb" }}>
            Vincular <strong style={{ color:"#3b82f6" }}>{usuarioSel.nombre} {usuarioSel.apellido}</strong>
            {" "}con<strong style={{ color:"#10b981" }}> {clienteSel.nombre} {clienteSel.apellido}</strong>
          </div>
          <div style={{ display:"flex", gap:"8px" }}>
            <button onClick={()=>{ setUsuarioSel(null); setClienteSel(null) }} style={{ ...BTN_GHOST, padding:"8px 16px" }}>Cancelar</button>
            <button onClick={vincular} disabled={vinculando} style={{ ...BTN_PRIMARY, padding:"8px 20px", background:"#10b981" }}>
              {vinculando ? "Vinculando..." : "✓ Confirmar vínculo"}
            </button>
          </div>
        </div>
      )}

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"20px" }}>

        {/* Lista izquierda — Usuarios registrados sin vincular */}
        <div className="admin__card">
          <div className="admin__card-header">
            <div className="admin__card-titulo">👤 Usuarios registrados sin vincular</div>
          </div>
          <div style={{ padding:"12px 16px 0" }}>
            <input
              className="admin__busqueda"
              placeholder="Buscar por nombre o email..."
              value={busU}
              onChange={e=>setBusU(e.target.value)}
              style={{ width:"100%", marginBottom:"10px" }}
            />
          </div>
          <div style={{ padding:"0 16px 16px", display:"flex", flexDirection:"column", gap:"6px", maxHeight:"420px", overflowY:"auto" }}>
            {cargando ? (
              <div className="admin__empty"><div className="admin__empty-texto">Cargando usuarios...</div></div>
            ) : usuariosFiltrados.length === 0 ? (
              <div className="admin__empty"><div className="admin__empty-icono">✅</div><div className="admin__empty-texto">No hay usuarios sin vincular</div></div>
            ) : usuariosFiltrados.map(u => (
              <button
                key={u.uid}
                onClick={() => setUsuarioSel(usuarioSel?.uid === u.uid ? null : u)}
                style={{
                  padding:"10px 14px", textAlign:"left",
                  background: usuarioSel?.uid === u.uid ? "#1e3a5f" : "#1a1a1a",
                  border: "1px solid " + (usuarioSel?.uid === u.uid ? "#3b82f6" : "#2a2a2a"),
                  borderRadius:"8px", cursor:"pointer", fontFamily:"Inter, sans-serif"
                }}
              >
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                  <div>
                    <div style={{ fontWeight:700, color: usuarioSel?.uid === u.uid ? "#3b82f6" : "#e5e7eb", fontSize:"0.875rem" }}>
                      {u.nombre} {u.apellido}
                    </div>
                    <div style={{ fontSize:"0.78rem", color:"#6b7280", marginTop:"2px" }}>{u.email}</div>
                  </div>
                  <button
                    onClick={e => { e.stopPropagation(); ocultarUsuario(u) }}
                    disabled={ocultando === u.uid}
                    style={{
                      background:"none", border:"1px solid #374151", borderRadius:"6px",
                      color:"#6b7280", fontSize:"0.72rem", fontWeight:700, cursor:"pointer",
                      padding:"3px 8px", whiteSpace:"nowrap", flexShrink:0
                    }}
                  >
                    {ocultando === u.uid ? "..." : "Ocultar"}
                  </button>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Lista derecha — Clientes sin cuenta */}
        <div className="admin__card">
          <div className="admin__card-header">
            <div className="admin__card-titulo">🧳 Clientes sin cuenta asociada</div>
          </div>
          <div style={{ padding:"12px 16px 0" }}>
            <input
              className="admin__busqueda"
              placeholder="Buscar cliente..."
              value={busC}
              onChange={e=>setBusC(e.target.value)}
              style={{ width:"100%", marginBottom:"10px" }}
            />
          </div>
          <div style={{ padding:"0 16px 16px", display:"flex", flexDirection:"column", gap:"6px", maxHeight:"420px", overflowY:"auto" }}>
            {clientesFiltrados.length === 0 ? (
              <div className="admin__empty"><div className="admin__empty-icono">✅</div><div className="admin__empty-texto">Todos los clientes tienen cuenta</div></div>
            ) : clientesFiltrados.map(c => (
              <button
                key={c.id}
                onClick={() => setClienteSel(clienteSel?.id === c.id ? null : c)}
                style={{
                  padding:"10px 14px", textAlign:"left",
                  background: clienteSel?.id === c.id ? "#0a2a1a" : "#1a1a1a",
                  border: "1px solid " + (clienteSel?.id === c.id ? "#10b981" : "#2a2a2a"),
                  borderRadius:"8px", cursor:"pointer", fontFamily:"Inter, sans-serif"
                }}
              >
                <div style={{ fontWeight:700, color: clienteSel?.id === c.id ? "#10b981" : "#e5e7eb", fontSize:"0.875rem" }}>
                  {c.nombre} {c.apellido}
                </div>
                <div style={{ fontSize:"0.78rem", color:"#6b7280", marginTop:"2px" }}>
                  {c.ciudad || "Sin ciudad"} · {(c.contrataciones||0)} viaje{(c.contrataciones||0)!==1?"s":""}
                </div>
              </button>
            ))}
          </div>
        </div>

      </div>

      {ocultos.length > 0 && (
        <div style={{ marginTop:"32px" }}>
          <div style={{ fontSize:"0.75rem", fontWeight:800, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.6px", marginBottom:"12px" }}>
            🚫 Usuarios ocultos ({ocultos.length})
          </div>
          <input
            className="admin__busqueda"
            placeholder="Buscar en ocultos..."
            value={busOcultos}
            onChange={e => setBusOcultos(e.target.value)}
            style={{ width:"100%", maxWidth:"320px", marginBottom:"10px" }}
          />
          <div style={{ display:"flex", flexDirection:"column", gap:"4px" }}>
            {ocultos
              .filter(u => `${u.nombre} ${u.apellido} ${u.email}`.toLowerCase().includes(busOcultos.toLowerCase()))
              .map(u => (
                <div key={u.uid} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"8px 12px", background:"#111", border:"1px solid #1f1f1f", borderRadius:"8px", gap:"12px" }}>
                  <div>
                    <div style={{ fontSize:"0.85rem", color:"#6b7280", fontWeight:600 }}>{u.nombre} {u.apellido}</div>
                    <div style={{ fontSize:"0.75rem", color:"#374151" }}>{u.email}</div>
                  </div>
                  <button
                    onClick={() => desocultar(u)}
                    style={{ background:"none", border:"1px solid #374151", borderRadius:"6px", color:"#6b7280", fontSize:"0.72rem", fontWeight:700, cursor:"pointer", padding:"3px 8px", whiteSpace:"nowrap", flexShrink:0 }}
                  >
                    Mostrar
                  </button>
                </div>
              ))
            }
          </div>
        </div>
      )}

      {ultimosRegistros.length > 0 && (
        <div style={{ marginTop:"32px" }}>
          <div style={{ fontSize:"0.75rem", fontWeight:800, color:"#4b5563", textTransform:"uppercase", letterSpacing:"0.6px", marginBottom:"12px" }}>
            🕐 Últimos registros
          </div>
          <div style={{ display:"flex", flexDirection:"column", gap:"6px" }}>
            {ultimosRegistros.map(u => {
              const fecha = u.creado_en?.toDate?.() || new Date(u.creado_en)
              const estaVinculado = !!u.id_cliente_asociado
              return (
                <div key={u.uid} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"10px 14px", background:"#1a1a1a", border:"1px solid #2a2a2a", borderRadius:"8px", gap:"12px" }}>
                  <div>
                    <div style={{ fontSize:"0.875rem", color:"#e5e7eb", fontWeight:600 }}>{u.nombre} {u.apellido}</div>
                    <div style={{ fontSize:"0.75rem", color:"#6b7280", marginTop:"2px" }}>{u.email}</div>
                  </div>
                  <div style={{ textAlign:"right", flexShrink:0 }}>
                    <div style={{ fontSize:"0.75rem", color:"#4b5563" }}>
                      {fecha.toLocaleDateString("es-AR", { day:"2-digit", month:"2-digit", year:"numeric" })}
                    </div>
                    <div style={{ marginTop:"3px" }}>
                      {estaVinculado
                        ? <span style={{ fontSize:"0.72rem", color:"#10b981", fontWeight:700 }}>✓ Vinculado</span>
                        : <span style={{ fontSize:"0.72rem", color:"#f59e0b", fontWeight:700 }}>Pendiente</span>
                      }
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
